/* RISKS MODULES*/
export const GET_RISKS_MODULES = "GET_RISKS_MODULES";
export const GET_RISKS_MODULES_SUCCESS = "GET_RISKS_MODULES_SUCCESS";
export const GET_RISKS_MODULES_FAIL = "GET_RISKS_MODULES_FAIL";

export const SET_SELECTED_RISK = "SET_SELECTED_RISK";
